import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOfficeFileGraphAlternate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "office-file-graph-alternate" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.812,5.559a1.5,1.5,0,0,1,.439,1.061V21A2.25,2.25,0,0,1,21,23.249H3A2.251,2.251,0,0,1,.751,21V3A2.25,2.25,0,0,1,3,.749H17.38a1.5,1.5,0,0,1,1.061.439Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.251.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 9.751,
			cy: 9.749,
			r: 5.25
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "4.502 9.749 9.732 9.749 10.878 14.878"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.732,
			y1: 9.749,
			x2: 13.464,
			y2: 6.037
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.501,
			y1: 16.499,
			x2: 15.001,
			y2: 16.499
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.501,
			y1: 19.499,
			x2: 11.251,
			y2: 19.499
		})
	]
});
export default SvgOfficeFileGraphAlternate;
